<template>
    <el-drawer
        :title="`${item.id?'编辑':'新增'}数据`"
        :visible.sync="show"
        :wrapperClosable="false"
        direction="rtl"
        size="950px"
        :before-close="close">
         <el-form ref="form" :model="form" label-width="150px" class="edit_form fx fx-m_center" style="width: 100%" v-for="(item, i) in form.uploadNum" :key="i">
            <div>{{i+1}}.</div>
            <div style="width: 280px">
                <el-form-item label="类型">
                    <el-select v-model="designListType[i]" clearable  placeholder="全部">
                        <el-option
                            v-for="item in typeOption"
                            :key="item.optionValue"
                            :label="item.optionText"
                            :value="item.optionValue">
                        </el-option>
                    </el-select>
                </el-form-item>
                <div style="width: 300px" v-if="designListType[i] == 3">
                    <el-form-item label="请输入标题">
                        <el-input v-model="designListTitle[i]" placeholder="请输入标题" ></el-input>
                    </el-form-item>
                </div>
                <div style="width: 300px">
                    <el-form-item label="请输入副标题">
                        <el-input v-model="designListSubTitle[i]" placeholder="请输入副标题" ></el-input>
                    </el-form-item>
                </div>
            </div>
            <div style="width: 420px">
                <el-form-item label="请输入关联数据">
                    <el-select v-model="designListName[i]"  remote filterable  placeholder="请输入关联数据"  :remote-method="(query)=>{search(query,designListType[i])}" @change="selectChanged">
                        <el-option
                            v-for="item in articles"
                            :key="item.id"
                            :label="designListType[i] == 2 ? item.title : item.name"
                            :value="{id:designList[i] !=null ? designList[i].id : null,linkId:item.id,name:designListType[i] == 2 ? item.title :item.name,index:i,type:designListType[i],flag:(i+1)}">
                        </el-option>
                    </el-select>
                </el-form-item>
                <div v-if="designListType[i] == 3">
                    <el-form-item label="显示文章数">
                        <el-input-number v-model="designListNumber[i]"  :min="1"  label="" ></el-input-number>
                    </el-form-item>
                </div>
            </div>
        </el-form>
        <span  class="fx fx-center">
            <el-button type="primary" @click="sub()">确 定</el-button>
            <el-button @click="close()">关 闭</el-button>
        </span>
    </el-drawer>

</template>


<style scoped>

</style>
<script>


    export default {
        props: [
            "item",
        ],
        components: {
        },
        data() {
            return {
                show: false,
                uploading: false,
                form: {...this.item,type:2},
                articles: {},
                needRefreshParent: false,
                typeOption: [],
                designList:[],
                designListType:[],
                designListName:[],
                designListTitle:[],
                designListSubTitle:[],
                designListNumber:[],
            }

        },


        methods: {
            close() {
                if (this.needRefreshParent) {
                    this.$emit("submit");
                } else {
                    this.$emit("close");
                }
            },
            sub() {
                let design = this.designList;
                design.forEach(item => {
                    if(item.index != undefined){
                        item.title = this.designListTitle[item.index];
                        item.subTitle = this.designListSubTitle[item.index];
                        item.number = this.designListNumber[item.index];
                    }
                })
                this.$emit("submit", design);
                return false;
            },

            selectChanged(params) {
                if(params != null){
                    this.designList[params.index] = params;
                    this.designListName[params.index] = params.name
                }

            },

            search(query,type) {
                this.form.keywords = query;
                let url = type == 2 ? "/dictionary/listBasicData" : "/articleType/listArticleType";
                this.$ajaxPost(url, {
                    form: {keywords:query}
                }, (data) => {
                    this.articles = data.result;
                })
            },
            loadTypes() {
                this.$ajaxGet("/common/websitePageLinkType", (data) => {
                    this.typeOption = data.result;
                })
            },
        },
        mounted() {
            this.show = true;
        },
        created() {
            this.loadTypes();
            if(this.item.list){
                let list = this.item.list;
                if(this.item.id > 0){
                    let index = 0;
                    list.forEach(item => {
                        this.designListType[index] = item.type;
                        this.designListName[index] = item.name;
                        this.designListNumber[index] = item.number;
                        this.designListTitle[index] = item.title;
                        this.designListSubTitle[index] = item.subTitle;
                        item.index = index;
                        index++;
                    })
                }else{
                    list.forEach(item => {
                        console.log(item.index)
                        this.designListType[item.index] = item.type;
                        this.designListName[item.index] = item.name;
                        this.designListNumber[item.index] = item.number;
                        this.designListTitle[item.index] = item.title;
                        this.designListSubTitle[item.index] = item.subTitle;
                    })
                }
                this.designList = list;
            }
        }


    }
</script>
